import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allJuegosAction } from '../../juegos/JuegosAction';
import { saveEquiposJuegosAction } from '../EquiposJuegosAction';

const FormEquiposJuegos = ({ setOpenModalForm = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const equiposJuegosStore = Redux.useSelector((state) => state.equiposJuegos);
  const juegosStore = Redux.useSelector((state) => state.juegos);
  const torneosStore = Redux.useSelector((state) => state.torneos);

  const activo = equiposJuegosStore.activo;

  const initData = {
    resultado: '',
    ganador: false,
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    resultado: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));

    setTimeout(
      () =>
        setData({
          ...values,
          resultado: activo.resultado,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveEquiposJuegosAction(
        { dispatch, notify },
        activo?.id,
        data,
        {
          idTorneo: torneosStore.activo.id,
          ...equiposJuegosStore.params,
        },
      );

      await allJuegosAction(dispatch, juegosStore.params);
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.resultado.name}
            required
            type="number"
            label={CONST.resultado.label}
            value={data.resultado}
            onChange={(e) =>
              _handleSetDataField(CONST.resultado.name, e.target.value)
            }
            helperText={dataError.resultado ? validMessage.required : null}
            error={dataError.resultado}
            InputProps={{
              inputProps: { min: 0 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.ganador}
                onChange={(e) => {
                  _handleSetDataField(CONST.ganador.name, e.target.checked);
                }}
              />
            }
            label={CONST.ganador.label}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEquiposJuegos;
